/**
 * Hero kapasite bilgileri: Ana Sayfa, Hizmetler, Hakkimizda ve Liman Ozellikleri hero'larinda
 * ayni uc deger ayni sirayla gosterilir:
 *
 *   250K TEU | 8M TON | 1.3M m²
 *   Yillik Kapasite | Yillik Kapasite | Liman Sahasi
 *
 * Veri portal > Ana Sayfa > "Ust Rakamlar" (Hizmetler Hero Istatistikleri, kategori 'hero')
 * kayitlarindan gelir. Canlidaki kayitlarin Sira degerleri bu sirayi tersten verdigi (1.3M m² once)
 * ve kutu sirasi icerik girene bagli oldugu icin sira birime gore sabitlenir: TEU, TON, m².
 * Birimi taninmayan deger (ornegin "120 Adet") en sona, gelis sirasini koruyarak eklenir.
 * Portal formu ayni kurali kullanir (portal/src/services/port-api.ts orderServicesHeroStats).
 */
export const HERO_STAT_LIMIT = 3;

const UNIT_ORDER: RegExp[] = [/\bteu\b/i, /\btons?\b/i, /m²|\bm2\b/i];

function unitRank(text: string): number {
  const index = UNIT_ORDER.findIndex((pattern) => pattern.test(text));
  return index === -1 ? UNIT_ORDER.length : index;
}

/** Birim deger alaninda yoksa (portal bazen etiketin basina yazar) etikete bakilir */
function statRank(stat: { value: string; label?: string }): number {
  const fromValue = unitRank(stat.value || '');
  return fromValue < UNIT_ORDER.length ? fromValue : unitRank(stat.label || '');
}

export function orderHeroStats<T extends { value: string; label?: string }>(
  stats: readonly T[],
  limit: number = HERO_STAT_LIMIT,
): T[] {
  return stats
    .map((stat, index) => ({ stat, index, rank: statRank(stat) }))
    .sort((a, b) => a.rank - b.rank || a.index - b.index)
    .slice(0, limit)
    .map((entry) => entry.stat);
}
